import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border border-border-secondary bg-bg-primary py-20 shadow-sm">
      {icon && (
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-bg-tertiary text-fg-tertiary">
          {icon}
        </div>
      )}
      <div className="text-center">
        <p className="font-medium text-text-primary">{title}</p>
        {description && (
          <p className="mt-1 text-sm text-text-tertiary">{description}</p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  )
}
